import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { share, first } from 'rxjs/operators';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { AutoCompleteComponent } from '../../../shared/components/autocomplete/autocomplete.component';
import { AutoCompleteSelectedItem } from '../../../shared/components/autocomplete/autocomplete.model';
import { VehicleMakeModel } from './vehicle-make-model.model';
import { VehicleMakeModelService } from './vehicle-make-model.service';
import { MakeModelCreate } from '../../models/make-model-create.model';
import { ValidationModel } from '../../../shared/models/validation-results/validation.model';

@Component({
    selector: 'VehicleMakeModel',
    templateUrl: './vehicle-make-model.html',
    inputs: ['vehicleMakeId', 'vehicleMakeDisplayValue', 'addingNewMake', 'vehicleTypeId']
})
export class VehicleMakeModelComponent extends BaseComponent {
    @ViewChild('newMakeAC', { static: true }) _newMakeAutoComplete: AutoCompleteComponent;
    @ViewChild('newModelAC', { static: true }) _modelAutoComplete: AutoCompleteComponent;
    private errors: string[] = new Array<string>();
    private _selectedMakeModel$ = new Subscriber<any>();
    private _tempMakeModel: VehicleMakeModel;
    private vehicleModelId: number;
    private vehicleModelDisplayValue: string;

    public vehicleMakeId: number;
    public vehicleTypeId: number;
    public vehicleMakeDisplayValue: string;
    public addingNewMake: boolean;
    // temporarily removed strongly typed 'VehicleMakeModel' to 'any' for angular rc3 upgrade
    public selectedMakeModel$: Observable<any>;

    constructor(public service: VehicleMakeModelService, private _route: ActivatedRoute) {
        super();
        this.selectedMakeModel$ = new Observable(o => this._selectedMakeModel$ = o).pipe(share());
    }

    ngOnInit() {
    }

    public init(vehicleMakeId: number, vehicleMakeDisplayValue: string, vehicleModelId: number, vehicleModelDisplayValue: string) {
        this.vehicleMakeId = vehicleMakeId;
        this.vehicleMakeDisplayValue = vehicleMakeDisplayValue;
        this.vehicleModelId = vehicleModelId;
        this.vehicleModelDisplayValue = vehicleModelDisplayValue;
        this._modelAutoComplete.parentValue = vehicleMakeId;

        // must have the make id when adding just a new model
        if (this.addingNewMake === false && (vehicleMakeId === null || vehicleMakeId === undefined)) {
            throw new Error('VehicleMakeModelComponent is unable to init() because the vehicleMakeId variable has not been set');
        }

        this._newMakeAutoComplete.serviceIdPath = 'vehicle/make';
        this._newMakeAutoComplete.servicePath = 'vehicle/make/name';
        this._modelAutoComplete.servicePath = 'vehicle/model/make/{parentId}/name';
        this._modelAutoComplete.serviceIdPath = 'vehicle/model';

        // initialize the autocomplete components
        if (this.addingNewMake) {
            this._newMakeAutoComplete.init(0, '');
            this._newMakeAutoComplete.disabled = false;
        } else {
            this._newMakeAutoComplete.init(this.vehicleMakeId, this.vehicleMakeDisplayValue);
            this._newMakeAutoComplete.disabled = true;
        }

        if (vehicleModelId === null || vehicleModelId === undefined) {
            this._modelAutoComplete.init(0, ''); // no model id defined
        } else if (vehicleModelDisplayValue !== null && vehicleModelDisplayValue !== undefined) {
            this._modelAutoComplete.init(vehicleModelId, vehicleModelDisplayValue); // both model id and description were provided
        }
    }

    /**
     * After the view has been initialzed
     */
    ngAfterViewInit() {
        if (this.addingNewMake) {
            this._newMakeAutoComplete.showItemNotFoundMessage = false;
            this._newMakeAutoComplete.selectedItem$.subscribe(selectedItem => this.setMakeValues(selectedItem));
        }

        this._modelAutoComplete.showItemNotFoundMessage = false;
        this._modelAutoComplete.selectedItem$.subscribe(selectedItem => this.setModelValues(selectedItem));
    }

    private setMakeValues(selectedItem: AutoCompleteSelectedItem) {
        this.vehicleMakeId = selectedItem.selectedValue;
        this.vehicleMakeDisplayValue = selectedItem.selectedText;
    }

    private setModelValues(selectedItem: AutoCompleteSelectedItem) {

        var makeModeItem: VehicleMakeModel = {
            makeId: this.vehicleMakeId,
            makeDisplayValue: this.vehicleMakeDisplayValue,
            modelId: selectedItem.selectedValue,
            modelDisplayValue: selectedItem.selectedText,
            isNewMake: false,
            isNewModel: selectedItem.selectedValue < 0
        };
        this._tempMakeModel = makeModeItem;
    }

    public addNewMake() {
        if (this._tempMakeModel != null && this._tempMakeModel != undefined) {
            let mm = new MakeModelCreate();
            mm.makeValue = this._tempMakeModel.makeDisplayValue;
            mm.modelValue = this._tempMakeModel.modelDisplayValue;
            mm.vehicleTypeId = this.vehicleTypeId;
            let self = this;
            this.service.createMakeModel(mm).subscribe(
                r => {
                    self._tempMakeModel.makeId = r.makeId;
                    self._tempMakeModel.modelId = r.modelId;
                    self._selectedMakeModel$.next(self._tempMakeModel);
                },
                e => {
                    this.handleValidationResult(e);
                    console.log(e);
                }
            );
        }
    }

    public async addNewModel() {
        if (this._tempMakeModel != null && this._tempMakeModel != undefined) {
            this.validationResults = new ValidationModel([]);
            this.showValidationComponent = false;
            let mm = new MakeModelCreate();
            mm.makeId = this._tempMakeModel.makeId;
            mm.modelValue = this._tempMakeModel.modelDisplayValue;
            let self = this;
            try {
                var makeModel = await this.service.createMakeModel(mm).pipe(first()).toPromise();
                if (makeModel) {
                    self._tempMakeModel.makeId = makeModel.makeId;
                    self._tempMakeModel.modelId = makeModel.modelId;
                    self._selectedMakeModel$.next(self._tempMakeModel);
                    self._modelAutoComplete.clear();
                }
            } catch (e) {
                super.handleValidationResult(e);
            }

            // this.service.createMakeModel(mm).subscribe(
            //    r => {
            //        self._tempMakeModel.makeId = r.makeId;
            //        self._tempMakeModel.modelId = r.modelId;
            //        self._selectedMakeModel$.next(self._tempMakeModel);
            //    },
            //    e => {
            //        this.handleValidationResult(e);
            //        console.log(e);
            //    }
            // );
        }
    }

    // handles any errors that occur from services
    handleValidationResult(error) {
        this.errors = new Array<string>();

        error.error.validationResults.forEach(error => {
            this.errors.push(error.errorMessage);
        });
    }
}
